import { ReactNode } from 'react';

export enum RequireAuthType {
  DELETE = 'delete',
  PUNISH = 'punish',
  AI_RECOMMEND_REPLY = 'aiRecommendReply',
  SHOW_MORE = 'showMore'
}

export interface RequireAuthModalContent {
  title: string;
  content: ReactNode;
  extra?: string;
}

export interface RequireAuthModalProps {
  showModal: boolean;
  handleShowModal: () => void;
  type: RequireAuthType;
}
